import AFFIN_BANK_IMG from '@/assets/images/Internet_Banking_MY/affin-bank-img.png';
import AGRO_BANK_IMG from '@/assets/images/Internet_Banking_MY/agro-bank-img.png';
import ALLIANCE_BANK_IMG from '@/assets/images/Internet_Banking_MY/alliance-bank-img.png';
import AMBANK_IMG from '@/assets/images/Internet_Banking_MY/ambank-img.png';
import BANK_ISLAM_IMG from '@/assets/images/Internet_Banking_MY/bank-islam-img.png';
import BANK_MUAMALAT_IMG from '@/assets/images/Internet_Banking_MY/bank-muamalat-img.png';
import BANK_OF_CHINA_IMG from '@/assets/images/Internet_Banking_MY/bank-of-china-img.png';
import BANK_RAKYAT_IMG from '@/assets/images/Internet_Banking_MY/bank-rakyat-img.png';
import BSN_IMG from '@/assets/images/Internet_Banking_MY/bsn-img.png';
import CIMB_BANK_IMG from '@/assets/images/Internet_Banking_MY/cimb-bank-img.png';
import HONG_LEONG_BANK_IMG from '@/assets/images/Internet_Banking_MY/hong-leong-bank-img.png';
import HSBC_IMG from '@/assets/images/Internet_Banking_MY/hsbc-img.png';
import KUWAIT_FINANCE_HOUSE_IMG from '@/assets/images/Internet_Banking_MY/kuwait-finance-house-img.png';
import MAYBANK_IMG from '@/assets/images/Internet_Banking_MY/maybank-img.png';
import OCBC_BANK_IMG from '@/assets/images/Internet_Banking_MY/ocbc-bank-img.png';
import PUBLIC_BANK_IMG from '@/assets/images/Internet_Banking_MY/public-bank-img.png';
import RHB_BANK_IMG from '@/assets/images/Internet_Banking_MY/rhb-bank-img.png';
import STANDARD_CHARTERED_IMG from '@/assets/images/Internet_Banking_MY/standard-chartered-img.png';
import UOB_IMG from '@/assets/images/Internet_Banking_MY/uob-img.png';

export const INTERNET_BANKING_MY_OPTIONS = [
  { code: 'RPP_RTP_ABB', name: 'Affin Bank', image: AFFIN_BANK_IMG },
  { code: 'RPP_RTP_ABMB', name: 'Alliance Bank', image: ALLIANCE_BANK_IMG },
  { code: 'RPP_RTP_AGROBANK', name: 'Agrobank', image: AGRO_BANK_IMG },
  { code: 'RPP_RTP_AMB', name: 'AmBank', image: AMBANK_IMG },
  { code: 'RPP_RTP_CIMBC_LICKS', name: 'CIMB Bank', image: CIMB_BANK_IMG },
  { code: 'RPP_RTP_BIMB', name: 'Bank Islam', image: BANK_ISLAM_IMG },
  { code: 'RPP_RTP_BKRM', name: 'Bank Rakyat', image: BANK_RAKYAT_IMG },
  { code: 'RPP_RTP_BMMB', name: 'Bank Muamalat', image: BANK_MUAMALAT_IMG },
  { code: 'RPP_RTP_BSN', name: 'Bank Simpanan Nasional (BSN)', image: BSN_IMG },
  { code: 'RPP_RTP_HLB', name: 'Hong Leong', image: HONG_LEONG_BANK_IMG },
  { code: 'RPP_RTP_HSBC', name: 'HSBC Bank', image: HSBC_IMG },
  { code: 'RPP_RTP_KFH', name: 'Kuwait Finance House', image: KUWAIT_FINANCE_HOUSE_IMG },
  { code: 'RPP_RTP_MB2U', name: 'Maybank', image: MAYBANK_IMG },
  { code: 'RPP_RTP_OCBC', name: 'OCBC', image: OCBC_BANK_IMG },
  { code: 'RPP_RTP_PBB', name: 'Public Bank', image: PUBLIC_BANK_IMG },
  { code: 'RPP_RTP_RHB', name: 'RHB Bank', image: RHB_BANK_IMG },
  { code: 'RPP_RTP_SCB', name: 'Standard Chartered', image: STANDARD_CHARTERED_IMG },
  { code: 'RPP_RTP_UOB', name: 'United Overseas Bank', image: UOB_IMG },
  { code: 'RPP_RTP_BOCM', name: 'Bank Of China', image: BANK_OF_CHINA_IMG },
];
